import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from '../../../../constants/moment';
import {
  toggleModal,
  getAll,
  setValue,
  createNew,
  update,
  deleteEntity,
  tableActions,
  
} from "../../../../../redux/actions/titleActions";
import {
  Button,
  Modal
} from "react-bootstrap";
import {
  TextField,
  FormHelperText,
  Chip,
  Avatar,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow
} from "@material-ui/core";
import DataTable from "../../../../helpers/datatable/DataTable";

import Loading from "../../../../helpers/loading/Loading";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import actionsFormatter from "../../../../helpers/datatable/formatters/actionsFormatter";
import { textFilter } from 'react-bootstrap-table2-filter';

function TitlesPage(props) {
  useEffect(() => {
    props.getAll(props.auth.user.token);
    return () => {
      // will unMount 
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const columns = [
    {
      dataField: "titleName",
      text: "Görev Tanımı",
      sort: true,
      filter: textFilter({
        placeholder: "Ara",
        style: {
          display: props.title.data.length > 0 ? "block" : "none"
        }
      }),
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "titleCode",
      text: "Görev Kodu",
      sort: true,
      filter: textFilter({
        placeholder: "Ara",
        style: {
          display: props.title.data.length > 0 ? "block" : "none"
        }
      }),
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "action",
      text: "",
      
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
      formatter: (cell, row) => {
        return actionsFormatter(cell, row, props.tableActions, props.auth.user.token)
      }

    }
  ];

  return <>
   <Loading show={props.title.isFetchingDetail} />
    <Modal backdrop="static" size="lg" show={props.title.showModal} onHide={() => props.toggleModal(false, "")}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i style={{ marginRight: 5 }} className={props.title.process === "create" ? "fa fa-plus" : props.title.process === "update" ? "fa fa-edit" : "fa fa-trash-alt"}></i>
          {props.title.process === "create" ? "Yeni Görev" : props.title.process === "update" ? "Görev Düzenle" : "Görev Sil"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.title.process === "create" || props.title.process === "update" ?
          <div>
            <TextField
              label="Görev Adı"
              style={{ margin: 8 }}
              placeholder="Görev Adı"
              autoComplete="off"
              error={props.title.name_error}
              value={props.title.name}
              onChange={(event) => props.setValue("name", event.target.value)}
              helperText={props.title.name_helpertext}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              FormHelperTextProps={{
                style: {
                  marginLeft: 0
                }
              }}
            />
            <TextField
              label="Görev Kodu"
              style={{ margin: 8 }}
              placeholder="Görev Kodu"
              autoComplete="off"
              error={props.title.code_error}
              value={props.title.code}
              onChange={(event) => props.setValue("code", event.target.value)}
              helperText={props.title.code_helpertext}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              FormHelperTextProps={{
                style: {
                  marginLeft: 0
                }
              }}
            />

            {
              props.title.process === "update" && props.title.detail !== null ?
                <>
                  <div className="separator separator-dashed my-7"></div>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>GÖREV DETAYLARI</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        props.title.detail.createdBy !== null ?
                          <TableRow>
                            <TableCell component="th" scope="row">
                              <FormHelperText>Oluşturan Kullanıcı / Zamanı</FormHelperText><br />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Chip
                                style={{ marginLeft: -5 }}
                                avatar={<Avatar>{String(props.title.detail.createdBy.name[0]).toUpperCase() + String(props.title.detail.createdBy.surname[0]).toUpperCase()}</Avatar>}
                                label={props.title.detail.createdBy.username}
                              /><br />
                              <small>{moment(props.title.detail.createdAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                              <small>{moment(props.title.detail.createdAt).fromNow()}</small>
                            </TableCell>
                          </TableRow> : null
                      }
                      {
                        props.title.detail.updatedBy !== undefined && props.title.detail.updatedBy !== null ?
                          <TableRow>
                            <TableCell component="th" scope="row">
                              <FormHelperText>Son Güncelleyen Kullanıcı / Zamanı</FormHelperText>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Chip
                                style={{ marginLeft: -5 }}
                                avatar={<Avatar>{String(props.title.detail.updatedBy.name[0]).toUpperCase() + String(props.title.detail.updatedBy.surname[0]).toUpperCase()}</Avatar>}
                                label={props.title.detail.updatedBy.username}
                              /><br />
                              <small>{moment(props.title.detail.updatedAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                              <small>{moment(props.title.detail.updatedAt).fromNow()}</small>
                            </TableCell>
                          </TableRow> : null
                      }
                    </TableBody>
                  </Table></> : null
            }
          </div>
          :
          props.table.row !== null && props.table.row.titleName ?
            <>
              <b>{'"'}{props.table.row.titleName}{'" '}</b> isimli görevi silmek üzeresiniz. İşlemi onaylıyor musunuz?
          </> : null
        }
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={props.title.isFetchingActions} variant="secondary" onClick={() => props.toggleModal(false, props.title.process)}>
          İptal
            </Button>
        <Button disabled={props.title.isFetchingActions} style={{ minWidth: 50, minHeight: 39, display: "flex", flexDirection: "row", alignItems: "center" }} onClick={() => {
          if (props.title.process === "create") {
            props.createNew(props.auth.user.token,
              [
                {
                  key: "name",
                  value: props.title.name,
                  required: true
                },
                {
                  key: "code",
                  value: props.title.code,
                  required: true
                }
              ])
          } else if (props.title.process === "update") {
            props.update(props.auth.user.token, props.table.row.id,
              [
                {
                  key: "name",
                  value: props.title.name,
                  required: true
                },
                {
                  key: "code",
                  value: props.title.code,
                  required: true
                }

              ], props.table.index);
          } else {
            props.deleteEntity(props.auth.user.token, props.table.row, props.table.index);
          }
        }} variant="primary">
          {
            props.title.isFetchingActions ?
              <span className="ml-3 spinner spinner-white"></span> :
              props.title.process === "delete" ? "Sil" : "Kaydet"
          }
        </Button>
      </Modal.Footer>
    </Modal>
    <DataTable
      handleModal={props.toggleModal}
      title="Tüm Görevler"
      buttonTitle="Yeni Görev"
      cardIcon="fa fa-tasks"
      buttonIcon="fa fa-plus"
      searchPlaceholder="Ara"
      data={props.title.data}
      columns={columns}
    />
  </>
}

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    title: state.title,
    table: state.table
  }
}

export default connect(mapStateToProps,
  {
    toggleModal,
    getAll,
    setValue,
    createNew,
    update,
    deleteEntity,
    tableActions,
    
  })(TitlesPage);
